import wordmarkCream from "@/assets/images/brand/prezynt-logo-cream-wordmark.png";
import icon from "@/assets/images/brand/prezynt-icon.png";

/**
 * Sidebar logo. The sidebar is teal in both themes, so the cream wordmark is
 * always the right asset; the icon-only mark shows when the sidebar collapses.
 * The `.logo-lg` / `.logo-sm` hooks are what the sidebar size modes toggle.
 */
const LogoBox = () => {
  return (
    <div className="logo-box">
      <a href="/" className="logo-link" aria-label="Prezynt admin home">
        <img src={icon} className="logo-sm" width={34} height={34} alt="" />
        <img src={wordmarkCream} className="logo-lg" height={38} alt="Prezynt" />
      </a>
    </div>
  );
};

export default LogoBox;
